<template>
  <div>
    <el-form class="padding" xs :model="ruleForm" :rules="rules" ref="ruleForm" status-icon validate-on-rule-change>
      <el-form-item label="名前(姓名)" prop="name">
        <el-input id="name" v-model="ruleForm.name"></el-input>
      </el-form-item>
      <el-form-item label="ふりがな(姓名)" prop="kana">
        <el-input v-model="ruleForm.kana"></el-input>
      </el-form-item>
      <el-form-item label="社名" prop="company">
        <el-input v-model="ruleForm.company"></el-input>
      </el-form-item>
      <el-form-item label="メールアドレス" prop="mailaddress">
        <el-input v-model="ruleForm.mailaddress"></el-input>
      </el-form-item>
      <el-form-item label="問い合わせ件名" prop="title">
        <el-input v-model="ruleForm.title"></el-input>
      </el-form-item>
      <el-form-item label="問い合わせ内容" prop="contactBody">
        <el-input type="textarea" v-model="ruleForm.contactBody" :rows="5"></el-input>
      </el-form-item>
      <el-form-item label prop="agree">
        <el-checkbox style="display:flex; justify-content:center; margin: 20px;" label="個人情報の保持の同意" name="agree"
          v-model="ruleForm.agree" required><a href="#contact">個人情報保護方針</a>の同意</el-checkbox>
      </el-form-item>
      <el-form-item style="display:flex; justify-content:center;  ">
        <el-button @click="recaptcha(), submitForm('ruleForm')" type="primary">送信内容確認</el-button>
        <el-button class="centered" style="margin-left: 170px; " @click="cancelClick">Clear</el-button>
      </el-form-item>
    </el-form>
    <div id="contact" name="contact">
      <h3>個人情報保護方針</h3>
      <p style="overflow: visible;">当サイトの運営に際し、お客様のプライバシーを尊重し個人情報に対して十分な配慮を行うとともに、
      <br>大切に保護し、適正な管理を行うことに努めております。
      </p>
      <div class="pi_01">
        <div style="padding: 20px;">
          <dl>
            <dt>【個人情報の利用目的】</dt>
            <dd>
              a）お客様のご要望に合わせたサービスをご提供するための各種ご連絡。<br>
              b）お問い合わせいただいたご質問への回答のご連絡。
            </dd>
          </dl>
          <ul style="margin-bottom : 16px">
            <li>公正かつ適正な手段で、上記目的に必要となる個人情報を収集します。</li>
            <li>要配慮個人情報を取得する際は、ご本人の同意を得るものとします。</li>
            <li>取得した個人情報・要配慮個人情報は、ご本人の同意なしに目的以外では利用しません。</li>
            <li>情報が漏洩しないよう対策を講じ、従業員だけでなく委託業者も監督します。</li>
            <li>国内外を問わず、ご本人の同意を得ずに第三者に情報を提供しません。</li>
            <li>ご本人からの求めに応じ情報を開示します。</li>
            <li>公開された個人情報が事実と異なる場合、訂正や削除に応じます。</li>
            <li>個人情報の取り扱いに関する苦情に対し、適切・迅速に対処します。</li>
            <li>本個人情報保護方針の適用範囲は本ホームページ内のみとします。</li>
            <li>個人情報保護方針の内容について、適宜見直し・改訂を行います。</li>
            <li>適用される法令や規範を遵守します。</li>
          </ul>
          <dl>
            <dt>【個人情報に関するお問い合わせ先】</dt>
            <dd>株式会社L.S.E 担当者: 阿座上 英治</dd>
          </dl>
        </div>

      </div>

    </div>

  </div>
</template>

<script>
export default {

  name: "contact-form",
  data() {
    const storeValue = this.$store.state.contact.values; //this.$store.getters["contact/values"];
    const initState = {
      name: "",
      kana: "",
      company: "",
      mailaddress: "",
      title: "",
      contactBody: "",
      agree: false,
      token: ""
    };

    //ふりがなのバリデーション
    var checkKana = (rule, value, callback) => {
      let kana = value.match(/^[ぁ-ん]+\s*[ぁ-ん]*$/);
      //console.log("kana", kana);
      if (kana === null) {
        callback(new Error("ひらがなで入力してください"));
      } else {
        callback();
      }
    };

    return {
      ruleForm: storeValue === null ? initState : storeValue,
      rules: {
        name: [
          {
            required: true,
            message: "名前を入力してください",
            trigger: "blur"
          },
          {
            min: 2,
            max: 100,
            message: "名前は２文字以上、100文字以下で入力してください",
            trigger: "blur"
          }
        ],
        kana: [
          {
            required: true,
            message: "ふりがなを入力してください",
            trigger: "blur"
          },
          {
            min: 2,
            max: 100,
            message: "ふりがなは２文字以上、100文字以下で入力してください",
            trigger: "blur"
          },
          { validator: checkKana, trigger: "blur" }
        ],
        mailaddress: [
          {
            required: true,
            message: "メールアドレスを入力してください",
            trigger: "blur"
          },
          {
            type: "email",
            message: "有効なメールアドレスを入力してください",
            trigger: "blur"
          }
        ],
        contactBody: [
          {
            required: true,
            message: "問い合わせ内容を入力してください",
            trigger: "blur"
          },
          {
            min: 5,
            max: 1000,
            message: "内容は5文字以上、1000文字以下で入力してください",
            trigger: "blur"
          }
        ],
        agree: [
          {
            required: true,
            message: "個人情報の保持の同意をお願いします",
            trigger: "change"
          }
        ]
      }
    };
  },
  props: {},
  components: {},

  created: function () {
    this.$store.commit("contact/stepActive", 0);
  },

  methods: {
    /**
     * reCAPTCHAトークン取得
     */
    async recaptcha() {
      // (optional) Wait until recaptcha has been loaded.
      await this.$recaptchaLoaded()

      // Execute reCAPTCHA with action "login".
      this.ruleForm.token = await this.$recaptcha('login')

      console.log(this.ruleForm.token)
    },

    //データをクリアして最初の状態に戻る
    cancelClick() {
      this.$store.dispatch("contact/clearContactValues", this.ruleForm);
      this.$router.go(0)
    },

    /**
     * 全フォーム入力確認
     * @param {*} formName  入力されたデータオブジェクト
     */
    submitForm(formName) {
      if (this.ruleForm.agree == false) {
        this.$message({
          showClose: true,
          message: "個人情報の保持の同意をお願いします",
          type: "error"
        });
        return false;
      }
      //入力値から不正なHTMLタグや属性を削除
      this.ruleForm.name = this.$sanitize(this.ruleForm.name);
      this.ruleForm.kana = this.$sanitize(this.ruleForm.kana);
      this.ruleForm.company = this.$sanitize(this.ruleForm.company);
      this.ruleForm.mailaddress = this.$sanitize(this.ruleForm.mailaddress);
      this.ruleForm.title = this.$sanitize(this.ruleForm.title);
      this.ruleForm.contactBody = this.$sanitize(this.ruleForm.contactBody);

      //入力されたデータがバリデーションに合格しているかどうかを検証
      this.$refs[formName].validate(valid => {
        console.log(valid);

        if (valid) {
          this.$store.dispatch("contact/setContactValues", this.ruleForm);
          this.$router.push("/confirm");
        } else {
          this.$message({
            showClose: true,
            message: "入力内容をご確認下さい。",
            type: "error"
          });
          return false;
        }
      });
    }
  }
};
</script>

<style scoped>
.padding {
  padding: 0 5%;
  margin-left: 20% !important;
  margin-right: 20% !important;
}

.pi_01 {
  overflow: auto;
  max-height: 250px;
  background-color: #ffffff;
  margin-right: 20px;
}

#contact {
  margin-left: 100px;
  line-height: normal;
  margin-bottom: 90px;
  max-width: 1200px;
}

dd {
  margin-bottom: 20px;
}

h3 {
  margin-bottom: 0px !important;
  margin-top: 100px !important;
  padding-bottom: 0px !important
}

li {
  list-style: disc;
}


#pi {
  margin-left: 20%;
  margin-right: 20%;
}

/**サイズを小さくしたときの個人情報保護表示の位置を変更
 */
@media (max-width: 960px) {
  #pi {
    margin: 0px;
  }
}

/**サイズを小さくしたときのフォームの位置を変更
 */
@media (max-width: 951px) {
  .centered {
    margin-left: 50px !important
  }
}

@media (max-width: 563px) {
  .centered {
    margin-left: 15px !important
  }
}

@media (max-width: 750px) {
  .padding {
  padding: 0;
  margin-left: 0 !important;
  margin-right: 0 !important;
}
}

</style>
